"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var address_1 = require("../address");

var formatters_1 = require("../formatters");

var utils_1 = require("../utils");

var identity = function identity() {
  return function (result) {
    return result;
  };
};

var PersonalRequestPayloads = /*#__PURE__*/function () {
  function PersonalRequestPayloads() {
    _classCallCheck(this, PersonalRequestPayloads);
  }

  _createClass(PersonalRequestPayloads, [{
    key: "getAccounts",
    value: function getAccounts() {
      return {
        method: 'personal_listAccounts',
        format: function format(result) {
          return result.map(address_1.Address.fromString);
        }
      };
    }
  }, {
    key: "newAccount",
    value: function newAccount(password) {
      return {
        method: 'personal_newAccount',
        params: [password],
        format: address_1.Address.fromString
      };
    }
  }, {
    key: "unlockAccount",
    value: function unlockAccount(address, password, duration) {
      return {
        method: 'personal_unlockAccount',
        params: [address.toString().toLowerCase(), password, duration],
        format: identity()
      };
    }
  }, {
    key: "lockAccount",
    value: function lockAccount(address) {
      return {
        method: 'personal_lockAccount',
        params: [address.toString().toLowerCase()],
        format: identity()
      };
    }
  }, {
    key: "importRawKey",
    value: function importRawKey(privateKey, password) {
      return {
        method: 'personal_importRawKey',
        params: [utils_1.bufferToHex(privateKey), password],
        format: address_1.Address.fromString
      };
    }
  }, {
    key: "sendTransaction",
    value: function sendTransaction(tx, password) {
      return {
        method: 'personal_sendTransaction',
        params: [_objectSpread({}, formatters_1.toRawTransactionRequest(tx), {
          condition: tx.condition
        }), password],
        format: identity()
      };
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(tx, password) {
      return {
        method: 'personal_signTransaction',
        params: [_objectSpread({}, formatters_1.toRawTransactionRequest(tx), {
          condition: tx.condition
        }), password],
        format: identity()
      };
    }
  }, {
    key: "sign",
    value: function sign(message, address, password) {
      return {
        method: 'personal_sign',
        params: [formatters_1.inputSignFormatter(message), address.toString().toLowerCase(), password],
        format: identity()
      };
    }
  }, {
    key: "ecRecover",
    value: function ecRecover(message, signedData) {
      return {
        method: 'personal_ecRecover',
        params: [formatters_1.inputSignFormatter(message), signedData],
        format: address_1.Address.fromString
      };
    }
  }]);

  return PersonalRequestPayloads;
}();

exports.PersonalRequestPayloads = PersonalRequestPayloads;